<script setup>
defineOptions({ inheritAttrs: false });
defineProps({ modelValue: { type: [String, Number], default: "" } });
defineEmits(["update:modelValue"]);
</script>
<template>
  <input
    v-bind="$attrs"
    class="input"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

